import { createSlice } from '@reduxjs/toolkit';
import { createSelectorFn } from './common';

const initialState = {
  whitelist: []
};

const whiteListSlice = createSlice({
  name: 'whiteList',
  initialState,
  reducers: {
    setWhiteList: (state, action) => {
      state.whitelist = action.payload;
    }
  }
});

export const { setWhiteList } = whiteListSlice.actions;
export const useWhiteListSliceSelector = createSelectorFn(whiteListSlice);
export default whiteListSlice;
